export const FETCHING_AIDAVIE_FILES = "FETCHING_AIDAVIE_FILES";
export const UPDATING_OPERATOR = "UPDATING_OPERATOR";
